import React from "react";
import { Outlet } from "react-router-dom";
import * as C from "../componentsM/index";
import WhatsAppButton from "../componentsM/WhatsAppButton";

const RootLayout = () => (
  <>
    <C.ScrollTop />
    <C.Navbar />
    <main className="site-content min-h-[60vh] pt-[4.5rem] lg:pt-[6.75rem]">
      <Outlet />
    </main>
    <C.Footer />
    <WhatsAppButton />
  </>
);

export default RootLayout;
